import { isNil } from 'lodash-es';
import type { PartnerBusinessDescriptor } from '../proxies/SearchProxy';
import type {
  PartnerAvailableInterval,
  PartnerDetailsDescriptor,
  PartnerServiceDescriptor,
} from '../redux/ducks/SearchDucks.types';

export const selectBestBusiness = (
  partnerProfile: PartnerDetailsDescriptor,
): PartnerBusinessDescriptor | undefined => {
  let targetBusiness: PartnerBusinessDescriptor | undefined = undefined;
  let targetBusinesses = partnerProfile.businesses.filter(
    (b) => b.active && b.default,
  );
  if (targetBusinesses.length > 0) {
    targetBusiness = targetBusinesses[0];
  } else {
    targetBusinesses = partnerProfile.businesses.filter((b) => b.active);
    if (targetBusinesses.length > 0) {
      targetBusiness = targetBusinesses[0];
    }
  }

  return targetBusiness;
};

export const selectBestService = (
  partnerProfile: PartnerDetailsDescriptor,
  selectedBusiness: PartnerBusinessDescriptor,
): PartnerServiceDescriptor | undefined => {
  const availableServices = partnerProfile.services.filter(
    (s) => s.active && selectedBusiness.services.includes(s.id),
  );

  let targetService = undefined;
  let targetServices = availableServices.filter((s) => s.active && s.default);
  if (targetServices.length > 0) {
    targetService = targetServices[0];
  } else {
    targetServices = availableServices.filter((s) => s.active);
    if (targetServices.length > 0) {
      targetService = targetServices[0];
    }
  }

  return targetService;
};

export const sortAvailableSlots = (
  intervals: PartnerAvailableInterval[],
  selectedInterval?: number,
) => {
  const slots = [...intervals].sort((a, b) => {
    let aScore = 0;
    let bScore = 0;
    const now = new Date().getTime();

    if (!isNil(selectedInterval) && selectedInterval > now) {
      aScore = Math.abs(a.start - selectedInterval);
      bScore = Math.abs(b.start - selectedInterval);

      return aScore - bScore;
    }

    if (a.premium) {
      aScore += 100;
    }
    if (a.fast) {
      aScore += 1000;
    }
    if (b.premium) {
      bScore += 100;
    }
    if (b.fast) {
      bScore += 1000;
    }

    if (aScore === bScore) {
      aScore += a.start - b.start > 0 ? 1 : -0;
      bScore += a.start - b.start > 0 ? 0 : 1;
    }

    return aScore - bScore;
  });

  return slots;
};
